



jQuery(function($){

    if ($('.magazine').length == 0){
        return;
    }

    $('input[name="magazine"]').on('change', function(){
        if ($(this).val() == "digitaal"){
            $('.magazine__form.digitaal').addClass('active');
            $('.magazine__form.post').removeClass('active');
        }
        else{
            $('.magazine__form.digitaal').removeClass('active');
            $('.magazine__form.post').addClass('active');
        }
    });

    
});